export enum BadgeModeEnum {
  NONE = 'NONE',
  PLAYER = 'PLAYER',
  HOST = 'HOST'
}
